var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExternalLinkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 566.7 566.7",
    style: {
      enableBackground: "new 0 0 566.7 566.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:66.6667;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:133.3333;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Interface__x2F__External_x5F_Link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    className: "st0",
    d: "M200,66.7h-60c-37.3,0-56,0-70.3,7.3C57.2,80.3,47,90.5,40.6,103.1c-7.3,14.3-7.3,32.9-7.3,70.3 v253.3c0,37.3,0,56,7.3,70.3c6.4,12.5,16.6,22.8,29.1,29.1c14.2,7.3,32.9,7.3,70.2,7.3h253.5c37.3,0,55.9,0,70.1-7.3 c12.5-6.4,22.8-16.6,29.2-29.2c7.3-14.2,7.3-32.9,7.3-70.2v-60.1 M533.3,200V33.3 M533.3,33.3H366.7 M533.3,33.3L300,266.7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinkIcon);
export default __webpack_public_path__ + "static/media/external_link_icon.a959b06081dfff13858fc482a1aca9b0.svg";
export { ForwardRef as ReactComponent };